export const selectUnreadCount = state => {
  return state.notifications.unreadCount;
};
export const selectChatUnreadCount = state => {
  return state.notifications.chatUnreadCount;
};
export const selectNotifications = state => {
  return state.notifications.notifications;
};

export const selectNotificationLastPage = state => {
  return state.notifications.lastPage;
};

export const selectIsFetchingNotifications = state => {
  return state.notifications.isFetchingNotifications;
};

export const selectNotificationCurrentPage = state => {
  return state.notifications.page;
};

export const selectIsMarkingNotificationAsRead = state => {
  return state.notifications.isMarkingNotificationAsRead;
};
